var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { EGDSIconSize } from '@egds/react-core/icons';
import { PositionType } from '@egds/react-core/menu';
import { HeaderShopMenu } from '../header-shop-menu';
import { getGCSectionData } from '../gc-section-data';
import { formatMenuListItems } from './util/header-nav-menu-links-util';
var SHOP_TRAVEL = 'ShopTravel';
var ALL_TRAVEL = 'AllTravel';
var HeaderNavMenuLinks = /** @class */ (function (_super) {
    __extends(HeaderNavMenuLinks, _super);
    function HeaderNavMenuLinks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderNavMenuLinks.prototype.render = function () {
        var _a = this.props, analytics = _a.analytics, globalComponentsContext = _a.globalComponentsContext, numberOfLinks = _a.numberOfLinks;
        var linkId = numberOfLinks === 0 ? SHOP_TRAVEL : ALL_TRAVEL;
        var navLinks = getGCSectionData(globalComponentsContext, 'header', 'navLinks');
        var menuLink = navLinks && navLinks.sectionData.find(function (link) { return link.id === linkId; });
        var menuLinkText = menuLink && menuLink.text;
        if (!menuLinkText) {
            return null;
        }
        var menuItems = formatMenuListItems(menuLink, analytics);
        return (React.createElement(ApplicableMenu, { id: linkId, analytics: analytics, menuLinkText: menuLinkText, menuItems: menuItems, showAsExpandable: true }));
    };
    return HeaderNavMenuLinks;
}(React.PureComponent));
export { HeaderNavMenuLinks };
export var ApplicableMenu = function (_a) {
    var id = _a.id, analytics = _a.analytics, menuLinkText = _a.menuLinkText, menuItems = _a.menuItems, showAsExpandable = _a.showAsExpandable;
    return (React.createElement(HeaderShopMenu, { id: "gc-custom-header-tool-bar-shop-menu", analytics: analytics, menuLinkText: menuLinkText, menuItems: menuItems, menuId: id, position: PositionType.LEFT, iconSize: EGDSIconSize.MEDIUM, showAsExpandable: showAsExpandable }));
};
//# sourceMappingURL=header-nav-menu-links.js.map